import type { RequestPayload } from "@inertiajs/core";
import { router } from "@inertiajs/react";
import { EducationReportForm } from "../../../components/report/form/EducationReportForm";
import { useYearContext } from "../../../hooks/useYearContext";
import { ContentShell } from "../../../layout/ContentShell";
import type { Coach } from "../../../models/coach";
import type { EducationReport } from "../../../models/reports/educationReport";
import type { EducationReportTranslations } from "../../../models/reports/educationReportTranslations";
import { report_path, reports_path } from "../../../routes";

type EducationReportEdit = {
  education_report: EducationReport;
  education_report_translations: EducationReportTranslations;
  coaches: Coach[];
};

export default function EducationReportEdit({ education_report, education_report_translations, coaches }: EducationReportEdit) {
  const { pathWithYearContext } = useYearContext();
  const onSubmit = (values: RequestPayload) => router.patch(pathWithYearContext(report_path, education_report.id), values);

  return (
    <ContentShell title={`Bericht ${education_report.title}`} onBack={() => router.get(pathWithYearContext(reports_path))}>
      <EducationReportForm
        coaches={coaches}
        onSubmit={onSubmit}
        educationReport={education_report}
        saveButtonLabel="Speichern"
        translations={education_report_translations}
      />
    </ContentShell>
  );
}
